import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { path: '/home', label: '问卜', icon: 'ri-question-answer-line', activeIcon: 'ri-question-answer-fill' },
  { path: '/divination', label: '打卦', icon: 'ri-coin-line', activeIcon: 'ri-coin-fill' },
  { path: '/interpretation', label: '解卦', icon: 'ri-book-open-line', activeIcon: 'ri-book-open-fill' },
  { path: '/profile', label: '我的', icon: 'ri-user-line', activeIcon: 'ri-user-fill' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-t border-background-200">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center gap-0.5 min-w-[64px] h-full px-2 cursor-pointer transition-colors duration-200"
            >
              <div className={`w-6 h-6 flex items-center justify-center ${isActive ? 'text-primary-500' : 'text-foreground-400'}`}>
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl`}></i>
              </div>
              <span className={`text-xs whitespace-nowrap ${isActive ? 'text-primary-500 font-medium' : 'text-foreground-400'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}